import { render, staticRenderFns } from "./InstantBookModal.vue?vue&type=template&id=62f61870"
import script from "./InstantBookModal.vue?vue&type=script&lang=js"
export * from "./InstantBookModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports